import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { AuthenticateUser } from '../Utilities';
import { isLoggedIn } from '../screens/Auth/AuthSlice';

const PrivateRoute = ({ component: Component, ...rest }) => {

    const authenticated = useSelector(isLoggedIn);
    return (
        <Route
            {...rest}
            render={props => authenticated ? (
                <Component {...props} />
            ) : (
                <Redirect to='/login' />
            )}
        >
        </Route>
    )
};

export default PrivateRoute;